import { API_URL as API, BACKEND_URL } from '../utils/config';
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';
import { Package } from 'lucide-react';


const Account = () => {
  const { user, token, loading: authLoading } = useAuth();
  const { t } = useLanguage();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token) {
      fetchOrders();
    }
  }, [token]);

  const fetchOrders = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API}/orders`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setOrders(response.data);
    } catch (error) {
      console.error('Failed to fetch orders:', error);
    } finally {
      setLoading(false);
    }
  };

  if (authLoading) {
    return (
      <div className="min-h-screen bg-[#F9F9F7] pt-32 pb-24 flex items-center justify-center">
        <p className="text-[#8A8A8A]">Loading...</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  return (
    <div className="min-h-screen bg-[#F9F9F7] pt-32 pb-24" data-testid="account-page">
      <div className="max-w-[1200px] mx-auto px-6 md:px-12">
        <h1 className="text-5xl md:text-7xl font-serif tracking-tight leading-none text-[#1A1A1A] mb-12">
          {t('account')}
        </h1>

        {/* User Info */}
        <div className="bg-white p-8 border border-[#E5E5E5] mb-12">
          <h2 className="text-2xl font-serif text-[#1A1A1A] mb-4">
            {language === 'no' ? 'Din informasjon' : 'Your Information'}
          </h2>
          <div className="space-y-2 text-base text-[#8A8A8A]">
            <p><span className="text-[#1A1A1A] font-medium">{t('firstName')}:</span> {user.first_name}</p>
            <p><span className="text-[#1A1A1A] font-medium">{t('lastName')}:</span> {user.last_name}</p>
            <p><span className="text-[#1A1A1A] font-medium">{t('emailAddress')}:</span> {user.email}</p>
          </div>
        </div>

        {/* Orders */}
        <div>
          <h2 className="text-2xl font-serif text-[#1A1A1A] mb-6">
            {language === 'no' ? 'Dine bestillinger' : 'Your Orders'}
          </h2>

          {loading ? (
            <div className="text-center py-12">
              <p className="text-[#8A8A8A]">Loading orders...</p>
            </div>
          ) : orders.length === 0 ? (
            <div className="bg-white p-12 border border-[#E5E5E5] text-center" data-testid="no-orders">
              <Package className="w-12 h-12 mx-auto mb-4 text-[#8A8A8A]" />
              <p className="text-[#8A8A8A]">
                {language === 'no' ? 'Du har ingen bestillinger ennå' : 'You have no orders yet'}
              </p>
            </div>
          ) : (
            <div className="space-y-6" data-testid="orders-list">
              {orders.map(order => (
                <div key={order.id} className="bg-white p-6 border border-[#E5E5E5]" data-testid={`order-${order.id}`}>
                  <div className="flex justify-between mb-4">
                    <div>
                      <p className="text-xs uppercase tracking-[0.2em] text-[#8A8A8A] mb-1">
                        {language === 'no' ? 'Ordrenummer' : 'Order ID'}
                      </p>
                      <p className="text-sm text-[#1A1A1A]">{order.id}</p>
                    </div>
                    <div>
                      <p className="text-xs uppercase tracking-[0.2em] text-[#8A8A8A] mb-1">
                        {language === 'no' ? 'Status' : 'Status'}
                      </p>
                      <p className="text-sm text-[#1A1A1A]">{order.status}</p>
                    </div>
                    <div>
                      <p className="text-xs uppercase tracking-[0.2em] text-[#8A8A8A] mb-1">
                        {t('total')}
                      </p>
                      <p className="text-sm text-[#1A1A1A]">{order.total_amount} {order.currency.toUpperCase()}</p>
                    </div>
                  </div>
                  <p className="text-xs text-[#8A8A8A]">
                    {new Date(order.created_at).toLocaleDateString()}
                  </p>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Account;